import { PropsWithChildren } from 'react';

import ChannelProvider from '@/channels/ChannelProvider';
import { encounterChecklistChannelName } from '@/channels/utils/channelNames';

import { Props } from './types';

const EncounterChecklistChannel = ({ children, personId }: PropsWithChildren<Props>) => {
  return (
    <ChannelProvider channelName={encounterChecklistChannelName(personId)}>
      {children}
    </ChannelProvider>
  );
};

export default EncounterChecklistChannel;
